/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Affiliates_DescriptionInputs */

const en_directory_resources_affiliates_description = /** @type {(inputs: Directory_Resources_Affiliates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about referral opportunities for audiences that use software, AI products, and practical tools.`)
};

const zh_directory_resources_affiliates_description = /** @type {(inputs: Directory_Resources_Affiliates_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果你的受众使用软件、AI 产品和实用工具，可咨询推荐合作机会。`)
};

/**
* | output |
* | --- |
* | "Ask about referral opportunities for audiences that use software, AI products, and practical tools." |
*
* @param {Directory_Resources_Affiliates_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_affiliates_description = /** @type {((inputs?: Directory_Resources_Affiliates_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Affiliates_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_affiliates_description(inputs)
	return zh_directory_resources_affiliates_description(inputs)
});
export { directory_resources_affiliates_description as "directory.resources.affiliates.description" }